import { SvgIconProps } from "@mui/material";
export const ArrowNextCircle = (props: SvgIconProps) => {
  return (
    <svg
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M17.4998 32.0834C25.554 32.0834 32.0832 25.5542 32.0832 17.5001C32.0832 9.44593 25.554 2.91675 17.4998 2.91675C9.44568 2.91675 2.9165 9.44593 2.9165 17.5001C2.9165 25.5542 9.44568 32.0834 17.4998 32.0834Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6626 22.6479L20.7959 17.5L15.6626 12.3521"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
